<template>
  <div class="login_main">
    <div class="login_box">
      <div class="top">
        <p class="logo"></p>
        <p class="logo_txt">{{ titleTxt }}</p>
      </div>
      <el-form
        :model="fromData"
        status-icon
        :rules="rules"
        ref="loginForm"
        label-width="0"
        class="demo-ruleForm"
      >
        <el-form-item class="item" prop="username">
          <el-input
            type="text"
            v-model="fromData.username"
            @keyup.enter.native="submitForm"
            autocomplete="off"
            placeholder="请输入用户账号"
          ></el-input>
        </el-form-item>
        <el-form-item class="item" prop="password">
          <el-input
            type="password"
            v-model="fromData.password"
            @keyup.enter.native="submitForm"
            autocomplete="off"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item class="item" prop="captcha" fromData="0" v-if="iscode">
          <el-input
            type="text"
            v-model="fromData.captcha"
            @keyup.enter.native="submitForm"
            autocomplete="off"
            placeholder="请输入验证码"
          ></el-input>
          <img src alt />
        </el-form-item> -->
        <el-form-item class="item" prop="captcha" style="position: relative;" v-if="fromData.password && fromData.username">
          <!-- 注意：prop与input绑定的值一定要一致，否则验证规则中的value会报undefined，因为value即为绑定的input输入值 -->
          <el-input v-model="fromData.captcha" placeholder="请输入验证码" style="width:32%;position: absolute;left:0;top:0"></el-input>
          <img :src="picSrc" alt style="width:120px;height:30px;position: absolute;left:150px;top:5px" @click="changeCap" />
          <el-button type="text" class="textbtn" @click="changeCap" style="position: relative;left:70%;top:5px">看不清，换一张</el-button>
        </el-form-item>
        <el-button
          type="primary"
          class="submit_btn"
          @click.stop="submitForm"
          v-loading="loading"
          :disabled="loading"
        >登 录</el-button>
      </el-form>
    </div> 
  </div>
</template>
<script>
import "assets/stylus/account.styl";
import account from "api/account.js";
import baseURL from '../../config'
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      picSrc: "",
      titleTxt: "携易中小企业进销存系统",
      loading: false,
      iscode: false,
      fromData: {
        username: "",
        password: "",
        captcha: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
          {
            pattern: /^([a-zA-Z0-9_]{3,20})$/,
            message: "请输入正确的登录账号",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9_]+$/,
            message: "请输入登录密码",
            trigger: "blur"
          }
        ],
        captcha: [
          { required: true, message: "请输入图片验证码", trigger: "blur" },
          {
            pattern: /^[a-zA-Z0-9_]+$/,
            message: "请输入图片验证码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getPic();
    //console.log(this.$route.query.redirect,88888);
  },
  methods: {
    ...mapActions("account", ["loginSuccess", "setUserMenu", "setTopMenu"]),
    ...mapActions("pages", ["closeAll"]),
    //获取验证码地址
    getPic() {
      this.picSrc = baseURL + "/drawImage?time=" + new Date().getTime();

      console.log(this.picSrc)
    },
    changeCap(){
      this.getPic();
    },
    //提交
    submitForm() {
      let vm = this;
      this.$refs["loginForm"].validate(async vaild => {
        if (!vaild) return false;
        this.loading = true;
        let res = await this.$post(account.login, this.fromData);

        debugger;
        this.loading = false;
        if (res.status) {
          this.closeAll(); //关闭所有
          this.loginSuccess({ userInfo: res.data });
          //获取用户菜单
          let userMenu = await this.$post(account.getMenu, {});
          //有授权
          if (userMenu.status && userMenu.data) {
            userMenu.data.sort(this.$myfn.compare("resourceId"));
            this.setUserMenu({ userMenuList: userMenu.data });
          } else {
            this.setUserMenu({ userMenuList: null });
          }

          if (
            !this.$route.query.redirect ||
            this.$route.query.redirect === "/login"
          ) {
            this.$router.push({ path: "/" });
          } else {
            this.$router.push({ path: this.$route.query.redirect });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
